import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * MobileProtectedRoute - Beskyttet rute for mobil PWA
 * Omdirigerer til mobil innlogging hvis bruker ikke er autentisert
 */
const MobileProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show mobile loading spinner while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <Loader2 className="w-10 h-10 text-cyan-500 animate-spin" />
      </div>
    );
  }

  // Redirect to mobile login if not authenticated
  if (!user) {
    return <Navigate to="/m/ruh/login" state={{ from: location }} replace />;
  }

  // Render protected component
  return children;
};

export default MobileProtectedRoute;
